import { useState } from 'react';

/**
 * Custom hook for managing controlled/uncontrolled component values
 * Follows the same pattern as form inputs where `value` makes it controlled
 * and `defaultValue` makes it uncontrolled
 */
export const useControlledValue = <T>(
  value: T | undefined,
  defaultValue: T | undefined,
  onChange?: (value: T) => void
) => {
  const [internalValue, setInternalValue] = useState<T | undefined>(
    defaultValue
  );

  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  const setValue = (newValue: T) => {
    if (!isControlled) {
      setInternalValue(newValue);
    }
    onChange?.(newValue);
  };

  return [currentValue, setValue] as const;
};
